/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import { client, withUnwrap } from '../.kubb/client'
import type { AuthLoginOptions, AuthLoginResponses } from '../models/AuthLogin'
import {
  authLoginResponseSchema,
  authLoginErrorSchema,
  authLoginBodySchema,
} from '../schemas/authLoginSchema'

/**
 * @summary Validate credentials. On a trusted device (valid `edy_td` cookie of THIS user) → issue a JWT
 * access+refresh pair straight away. Otherwise email a 6-digit login code and return `codeRequired` +
 * `pendingToken` — no token, no refresh cookie; the session comes from `auth/login/verifyCode`.
 * Session-free: no legacy session is created (the old⇄new bridge mints it on demand).
 * {@link /api/v4/auth/login}
 */
export function authLogin<ThrowOnError extends boolean = true>(
  options: Options<AuthLoginOptions, ThrowOnError>
): Unwrappable<RequestResult<AuthLoginResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'POST',
      url: '/api/v4/auth/login',
      validator: {
        request: authLoginBodySchema,
        response: authLoginResponseSchema,
        error: authLoginErrorSchema,
      },
      contentType: { request: 'application/json-patch+json' },
      ...config,
    }) as Promise<RequestResult<AuthLoginResponses, ThrowOnError>>
  )
}
